import { BASE_URL } from '@olo-web/utils/common/constants';
import { useRouter } from 'next/router';
import React from 'react';
import { Link } from '../../Link';

// TODO: Need help with typing -@stnmonroe :(

export const LinkWrapper = React.forwardRef(
  ({ path, children, style, newTab, className, as }: any, ref: any): JSX.Element => {
    const router = useRouter();
    const { type }: any = router.query;
    const embedded = type && ['iframe', 'embed'].includes(type);

    let styleObj = { textDecoration: 'none' };
    if (style) styleObj = { ...styleObj, ...style };

    const isHttpsOrHttp = (path || '').slice(0, 10).includes('http');

    if (!embedded && !isHttpsOrHttp && !newTab) {
      return (
        <Link href={path} as={as} style={styleObj} ref={ref} className={className}>
          {children}
        </Link>
      );
    } else {
      const href = isHttpsOrHttp ? path : `${BASE_URL}${path}`;
      const childrenText = typeof children === 'string' ? children : undefined;
      const ariaLabel = childrenText
        ? `${childrenText} (opens in new window)`
        : 'Link (opens in new window)';
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={styleObj}
          ref={ref}
          className={className}
          aria-label={ariaLabel}
        >
          {children}
        </a>
      );
    }
  }
);
